import { DynamicFormGenerator as AntdDynamicFormGenerator } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const DynamicFormGenerator = forwardRef((props, ref) => {
  return <AntdDynamicFormGenerator ref={ref} {...props} />
})

export default DynamicFormGenerator
